import Vue    from 'vue'
import Router from 'vue-router'
import Main   from './components/Main.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'Kendeda EUI Visualizer',
    component: Main
  }]
})
